<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Online Payment Guide
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      
      <v-row no-gutters class="px-2 px-md-5">
        <v-col cols="12">
          <h1 class="text-h4 text-md-h3">Online Payment Guide</h1>
          <p>
            Miri motorists’ can now purchase credits effective 26 March 2016 at all 14 BPS parking coupon booth to pay for their compounds online, 24/7 by downloading BPS mobile apps or using the web at online.borneoparking.com. Purchase of credits using credit cards and online banking are available through the web at online.borneoparking.com only. There will be a convenience charge of 3% by a third party payment gateway for those using credit card or online banking to purchase credits.<br><br>
            Motorists can purchase credits as little as RM5.00, RM10.00 and so forth at all BPS parking booths and the system will generate a receipt with a 16 digits number. The motorist will then use the mobile apps or the web to register one time only with their email and a log-in password. After log in, motorists’ go to the reload screen to reload the credits with the 16 digits provided in the receipt to start making payments online. For those using credit card or online banking, credits will be auto reloaded into their account.<br><br>
          </p>

          <div class="mb-12">
            <p class="font-weight-medium">
              Mobile Application Guides
            </p>
            <v-expansion-panels class="my-4" variant="popout">
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    1. Download the App
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Download the 'BorneoParkKCH' appplication from Apple Store (for IOS) or Play Store (for Android)</p><br>
                    <div class="video-wrapper mb-4">
                      <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/eZwrxEL-hR0"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        style="max-width: 560px; aspect-ratio: 16/9;"
                      ></iframe>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    2. Registration and Login Instructions
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>On the front page, click on “Sign Up”. Email Address is required as the username and creates your password. Confirmation registration will send to the registered user’s email. After registration, log in with the email address and password.</p><br>
                    <v-img src="@/assets/mobile-app-guide-2.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    3. Check for Unpaid Over Parking Notices and Compounds
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Enter the vehicle registration number to search for any unpaid Over Parking Notices and Compounds.</p><br>
                    <v-img src="@/assets/mobile-app-guide-3.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    4. Outstanding Notices Payment
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>All the outstanding unpaid Over parking Notices and Compound notices within 14 days from the Date of Issuance will be shown here. Select the over parking notices and compound notices for payment.</p><br>
                    <v-img src="@/assets/mobile-app-guide-4.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    5. View Transaction History
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Navigate to the "History" section in the app and select the desired transaction type from the available options. This will filter the history to show only the selected type.</p><br>
                    <v-img src="@/assets/mobile-app-guide-5.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    6. Reload Balance
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Go to the main page and click on the "Reload" button, or Click the menu icon on the top left to open the side menu and select "Reload". </p><br>
                    <v-img src="@/assets/mobile-app-guide-6(1).jpeg" class="mb-4" max-width="300" contain></v-img>
                    
                    <p>Select the desired amount to reload, then pick the preferred payment option (Sarawak Pay or Online Banking/Credit Card), which will redirect to the chosen payment platform to complete the transaction. Alternatively, for reload numbers, enter the 16-digit reload number and complete the process by clicking the "Reload" button.</p><br>
                    <v-img src="@/assets/mobile-app-guide-6(2).jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    7. Vehicle Registration
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Navigate to the "Vehicles" section by clicking the vehicle icon in the bottom navigation bar, then click on the "Add Vehicle" button. Enter the vehicle's number, color, brand, and model in the provided fields, and once all details are entered, click on the "Add" button to complete the registration.</p><br>
                    <v-img src="@/assets/mobile-app-guide-7.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    8. Season Parking Purchase Guide
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>Navigate to the season parking section by clicking the "Season" tab in the bottom navigation bar, then click on the "Purchase Season Parking" button.</p><br>
                    <v-img src="@/assets/mobile-app-guide-8(1).jpeg" class="mb-4" max-width="300" contain></v-img>

                    <p>Select the vehicle for which the season parking pass is being purchased, choose the desired zone, and follow the prompts to complete the transaction.</p><br>
                    <v-img src="@/assets/mobile-app-guide-8(2).jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    9. Offstreet Payment Guide
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>On the main page, click the "Offstreet" button to navigate to the offstreet payment page, then select the desired offstreet car park. Choose the vehicle (if already registered) or manually enter the vehicle number, and finally, click the "Pay Now" button to proceed with the transaction and complete the process.</p><br>
                    <v-img src="@/assets/mobile-app-guide-9.jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-title>
                    10. Parking Coupon Payment Guide
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <p>On the main page, click the blue "Parking" button to go to the parking coupon payment page. Choose the registered vehicle number</p><br>
                    <v-img src="@/assets/mobile-app-guide-10(1).jpeg" class="mb-4" max-width="300" contain></v-img>
                    <p>Select the zone and time, and finally proceed with the transaction to complete the process.</p><br>
                    <v-img src="@/assets/mobile-app-guide-10(2).jpeg" class="mb-4" max-width="300" contain></v-img>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'OnlinePaymentGuidePage'
};
</script>

<style scoped>
.video-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.video-wrapper iframe {
  width: 100%;
  height: auto;
  min-height: 200px;
}

@media (max-width: 600px) {
  .video-wrapper iframe {
    max-width: 100%;
    height: 200px;
  }
}

@media (min-width: 601px) {
  .video-wrapper iframe {
    height: 315px;
  }
}
</style>